<template>
  <el-container class="comand-center-contaniner">
    <div class="menu">
      <div class="box1">
        <span>业务受理</span><label>|</label
        ><span style="opacity: 0.5" @click="$router.push('/command/map')">应急联动</span>
      </div>
      <el-menu
        @select="selectMenu"
        :default-active="menuSelected"
        class="el-menu-vertical-demo"
      >
        <el-menu-item index="/command/pending">
          <span style="position: relative" slot="title">
            <span class="lable-number" v-if="value > 0">{{ value }}</span>
            <span style="font-size: 12px">待受理</span>
          </span>
        </el-menu-item>
        <el-menu-item index="/command/processing">
          <span style="position: relative" slot="title">
            <span class="lable-number" v-if="value1 > 0">{{ value1 }}</span>
            <span style="font-size: 12px">处理中</span></span
          >
        </el-menu-item>
        <el-menu-item index="/command/finish">
          <span slot="title"> <span style="font-size: 12px">已完成</span></span>
        </el-menu-item>
        <el-menu-item index="/command/up-report">
          <span slot="title"><span style="font-size: 12px">已上报</span></span>
        </el-menu-item>
        <el-menu-item index="/command/participation">
          <span slot="title"><span style="font-size: 12px">已参与</span></span>
        </el-menu-item>
      </el-menu>
    </div>

    <div class="contentBox command-container-box">
      <router-view></router-view>
    </div>

    <el-dialog
      custom-class="tips-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="超时提醒"
      :visible.sync="showOverdue"
      width="400px"
      :before-close="handleClose"
    >
      <div>
        <span>{{
          userName && userName != "null" && userName != null
            ? userName
            : phone
            ? phone
            : ""
        }}</span>
        <span
          >,你有 <i class="danger-word">{{ overdueNum }}</i> 条报警超时未处理</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">知道了</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import { listAPI } from "@/api-path/command-center.js";
export default {
  name: "comand-center-contaniner",
  data() {
    return {
      menuSelected: "",
      userName: localStorage.getItem("p") || "",
      phone: localStorage.getItem("phone") || "",
      showOverdue: false,
      overdueNum: 0,
    };
  },
  computed: {
    value: function () {
      return this.$store.state.pendingCount;
    },
    value1: function () {
      return this.$store.state.processingCount;
    },
    visionGroupId() {
      return this.$store.state.visionGroupId;
    },
  },
  watch: {
    visionGroupId(newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.menuSelected = this.$route.path;
        }, 1000);
      }
    },
  },
  created() {
    this.menuSelected = this.$route.path;
    this.caseRed();
    this.getOverdue();
  },
  methods: {
    //获取逾期处理事件数量
    getOverdue() {
      this.$http.get(listAPI.queryOverdue).then((res) => {
        if (res.status === 200) {
          if (res.result != 0) {
            this.showOverdue = true;
            this.overdueNum = res.result;
          }
        }
      });
    },
    handleClose() {
      this.showOverdue = false;
    },
    caseRed() {
      this.$http.get(listAPI.caseRed).then((res) => {
        if (res.status === 200) {
          let value = res.result.TOBEPROCESSED >= 99 ? "99+" : res.result.TOBEPROCESSED;
          let value1 = res.result.PROCESSING >= 99 ? "99+" : res.result.PROCESSING;
          this.$store.commit("setAlarmCount", {
            name: "pendingCount",
            value,
          });
          this.$store.commit("setAlarmCount", {
            name: "processingCount",
            value: value1,
          });
        }
      });
    },
    selectMenu(index) {
      this.caseRed();
      this.$router.push(index);
      this.$store.commit("setVisionGroupId", "");
    },
  },
};
</script>

<style lang="less">
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .tips-dialog {
    .danger-word {
      color: red;
      font-size: 16px;
      font-weight: bold;
      font-style: normal;
    }
    .el-dialog__header {
      background: #04223e;
      .el-dialog__title {
        color: #fff;
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
.command-container-box {
  width: calc(100vw - 240px);
  .list-box {
    display: flex;
    height: 100%;
    padding: 20px 10px 0;
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    > div {
      height: 100%;
    }
    .tree {
      padding-right: 10px;
      border-right: 1px solid #ccc;
    }
    > .right-box {
      padding-left: 10px;
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      box-sizing: border-box;
    }
  }
}
.lable-number {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: red;
  display: inline-block;
  right: -20px;
  top: -10px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}
</style>
<style scoped lang="less">
@import "comand-center-contaniner";
</style>
